import React, { useEffect, useContext } from 'react';
import { store, net_api_url } from 'components/Store';
import Loading from './Loading';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router';
import getUrlParam, { decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';
import * as Sentry from '@sentry/react';

const Register = ({ login }) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { app_url } = state;
  const navigate = useNavigate();
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const emailFromUrl = getUrlParam('email');
  useEffect(() => {
    try {
      if (isAuthenticated) {
        navigate(`/${window.location.search}`);
      } else {
        let initialOptions = {
          authorizationParams: {
            redirect_uri: `${app_url}/login-success${window.location.search}`,
            netApiUrl: `${net_api_url}`,
            site: `${import.meta.env.VITE_APP_SITE}`,
          },
        };
        if (login) {
          loginWithRedirect(initialOptions);
        } else {
          initialOptions = {
            fragment: 'register',
            ...initialOptions,
          };
          let options =
            emailFromUrl !== undefined
              ? {
                  ...initialOptions,
                  login_hint: decodeUrlQueryValue(emailFromUrl),
                }
              : initialOptions;

          loginWithRedirect(options);
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  }, [isAuthenticated]);
  return (
    <>
      <Loading />
    </>
  );
};

export default Register;
